// ConfirmDialog.jsx
import React from 'react'
import PropTypes from 'prop-types'
import { injectIntl } from 'react-intl'

import styles from '../../../css/notifications.module.css'

const ConfirmDialog = ({
  cancelButtonText,
  cancelCallback,
  confirmButtonText,
  confirmCallback,
  intl,
  question,
  title,
  value,
  visible,
}) => {
  if (visible) {
    const YES = intl.formatMessage({
      id: 'general.yes',
      defaultMessage: 'YES',
      description: 'Yes button',
    })

    const CANCEL = intl.formatMessage({
      id: 'setting.cancel',
      defaultMessage: 'CANCEL',
      description: 'Cancel button',
    })

    // The gray page background
    const backdropStyle = {
      backgroundColor: 'rgba(0,0,0,0.3)',
      bottom: 0,
      left: 0,
      position: 'fixed',
      right: 0,
      top: 0,
      zIndex: 998,
    }

    const popupStyle = {
      backgroundColor: 'white',
      borderRadius: '.5em',
      color: '#D00000',
      fontSize: '1.5em',
      padding: '.5em',
      position: 'fixed',
      top: '50%',
      left: '50%',
      width: '250px',
      zIndex: 999,
      transform: 'translate(-50%, -50%)',
    }

    const buttonStyle = {
      border: 'none',
      fontSize: 'smaller',
      marginRight: '5px',
      padding: '.5em',
    }

    const cancelButtonStyle = {
      ...buttonStyle,
      backgroundColor: 'white',
      color: '#D00000',
    }

    const buttonContainerStyle = {
      bottom: '1em',
      right: '1em',
      textAlign: 'right',
      width: '100%',
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-around',
      padding: '20px',
    }

    const confirmButtonStyle = {
      ...buttonStyle,
      backgroundColor: '#D00000',
      color: 'white',
    }

    const questionStyle = {
      overflowWrap: 'break-word',
      textAlign: 'center',
      padding: '0px 20px',
    }

    const titleStyle = {
      fontSize: 'larger',
      textAlign: 'center',
      textTransform: 'uppercase',
      width: '100%',
      padding: '20px',
    }

    return (
      <div style={backdropStyle}>
        <div style={{ borderRadius: '10px' }}>
          <div style={popupStyle}>
            {title && (
              <div style={titleStyle}>
                {title}
              </div>
            )}
            {question && (
              <div style={questionStyle}>
                {question}
              </div>
            )}
            <div style={buttonContainerStyle}>
              <button
                style={confirmButtonStyle}
                type='button'
                onClick={() => confirmCallback(value)}
              >
                {confirmButtonText || YES}
              </button>
              <button
                className={styles.notificationWarning}
                style={cancelButtonStyle}
                type='button'
                onClick={() => cancelCallback()}
              >
                {cancelButtonText || CANCEL}
              </button>
            </div>
          </div>
        </div>
      </div>
    )
  }

  // not visible
  return ''
}

ConfirmDialog.propTypes = {
  failureMessage: PropTypes.string,
  intl: PropTypes.object,
  outcome: PropTypes.string,
  successMessage: PropTypes.string,
  systemErrorMessage: PropTypes.string,
  timeout: PropTypes.number,
  visible: PropTypes.bool,
}

export default injectIntl(ConfirmDialog)
